export enum TabName {
  CRITICAL = 'critical',
  WILL_BE_UNLINKED = 'will_be_unlinked',
}

export enum TabState {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  DISABLED = 'disabled',
}

export type TabData = {
  name: TabName;
  amount: number;
  state: TabState;
};

export type CPDashboardTabProps = {
  name: TabName;
  amount: number;
  onSelect: (tabName: TabName) => void;
  state: TabState;
  disabled?: boolean;
};

export type WrapperProps = {
  isActive?: boolean;
};
